// Het kwalificeringsantwoord dat de server op het huishouden zette
// (Adresses.Qualifying). De punt in de sleutel is in Firestore een nesting:
// 'energiearmoede.kouTochtVocht' staat onder Qualifying.energiearmoede.kouTochtVocht.
//
// Spiegel van `storedEntry` in functions/households/planQualifyingAnswers.js;
// functions/households/qualifyingAnswerFor.parity.test.js houdt ze gelijk. De
// server is de bron: hij schrijft de vorm.
//
// AI-CONTEXT: See docs/features/kwalificering-op-huishouden.md

/**
 * @typedef {object} QualifyingAnswer
 * @property {string} Answer - OptionKey: 'ja' of 'nee'
 * @property {{toDate: () => Date}} [AnsweredAt] - Firestore-Timestamp van het antwoord
 * @property {string} [ResearchID] - Onderzoek waarin het antwoord gegeven is
 * @property {string} [MomentID]
 * @property {string} [ResponseID]
 */

/**
 * @param {object} household - Adresses-document
 * @param {string} key - QualifyingKey, bv. 'energiearmoede.kouTochtVocht'
 * @returns {QualifyingAnswer|undefined}
 */
export const qualifyingAnswerFor = (household, key) =>
    key.split('.').reduce((node, part) => (node && typeof node === 'object' ? node[part] : undefined), household.Qualifying)

export default qualifyingAnswerFor
